import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Loading from '../../../common/component/Loading'
import ReactStringReplace from 'react-string-replace'

class SharedFileList extends Component {
  constructor (props) {
    super(props)
    this.state = {isSharedFileCategorySettingLoaded: false, isSharedFileSettingLoaded: false, targetCategory: '', isEditingCategory: false}
  }
  componentWillMount () {
    this.load('SharedFileSetting')
    this.load('SharedFileCategorySetting')
  }
  load (target) {
    const onSuccess = (res) => {
      const systemSettingValue = res.body.data.systemSettingValue
      this.setState({
        ['is' + target + 'Loaded']: true,
        [target]: systemSettingValue
      })
    }
    const params = {
      command: 'get',
      systemSettingName: target
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  saveCategory () {
    const onSuccess = (res) => {
      this.setState({
        isEditingCategory: false
      })
    }
    const systemSettingValue = this.state.SharedFileCategorySetting
    const params = {
      command: 'set',
      systemSettingName: 'SharedFileCategorySetting',
      systemSettingValue: systemSettingValue
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  selected (sharedFileId, e) {
    this.props.history.push('/' + this.userRoleUrl + '/shared_files/detail/' + sharedFileId)
  }
  selectCategory (categoryId) {
    this.setState({
      targetCategory: categoryId
    })
  }
  renderSharedFileCategorySetting (state) {
    return state.SharedFileCategorySetting.map((sharedFileCategory) => {
      return (<li key={sharedFileCategory.id} className={state.targetCategory === sharedFileCategory.id ? 'active' : ''}>
        <a onClick={(e) => this.selectCategory(sharedFileCategory.id)}><i className='icon-chevron-right pull-right' />{sharedFileCategory.name}</a>
      </li>)
    })
  }
  renderSharedFileBox (state) {
    let sharedFileCategorySetting = state.SharedFileCategorySetting
    if (state.targetCategory) {
      sharedFileCategorySetting = sharedFileCategorySetting.filter((e) => e.id === state.targetCategory)
    }
    return sharedFileCategorySetting
        .map((sharedFileCategory) => {
          const sharedFileList = state.SharedFileSetting.filter((e) => e.categoryId === sharedFileCategory.id)
          let sharedFileListToShow = sharedFileList.map((sharedFile) => {
            return (
              <tr key={sharedFile.id} onClick={(e) => this.selected(sharedFile.id, e)}>
                <td>{sharedFile.title}</td>
                <td>{sharedFile.year}/{this.zeroPack(sharedFile.month)}/{this.zeroPack(sharedFile.day)}&nbsp;{this.zeroPack(sharedFile.hour)}:{this.zeroPack(sharedFile.minutes)}</td>
              </tr>
            )
          })
          if (sharedFileListToShow.length === 0) {
            sharedFileListToShow = <tr key='zero'><td colSpan='3' style={{textAlign: 'center'}}>現在このカテゴリーで登録されている共有ファィルはありません</td></tr>
          }
          return (
            <div key={sharedFileCategory.id} className='box'>
              <div className='box-header'>
                <i className='icon-file icon-large' />
                <h5>{sharedFileCategory.name}</h5>
              </div>
              <div className='box-content box-table'>
                <table className='table table-hover tablesorter'>
                  <thead>
                    <tr>
                      <th>ファイル名称</th>
                      <th className='kw-list-date'>最終更新日時</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sharedFileListToShow}
                  </tbody>
                </table>
              </div>
            </div>
          )
        })
  }
  nl2br (text) {
    if (!(typeof (text) === 'string' || text instanceof String)) return
    const regex = /(\n)/g
    return text.split(regex).map(function (line, index) {
      if (line.match(regex)) {
        return React.createElement('br', { key: index })
      } else {
        return line
      }
    })
  }
  zeroPack (text) {
    return ('0' + text).slice(-2)
  }
  convHttpLink (text) {
    const regExp = /(https?:\/\/\S+)/g
    return ReactStringReplace(text, regExp, (match, i) => (
      <a key={text} href={match} target='_blank'>{match}</a>
    ))
  }
  renderCategoryListBox () {
    const sharedFileCategorySelector = this.renderSharedFileCategorySetting(this.state)
    return (
      <ul className='nav nav-list' id='person-list'>
        <li className='nav-header'>カテゴリ</li>
        <li className={this.state.targetCategory === '' ? 'active' : ''} onClick={(e) => this.selectCategory('')}>
          <a id='view-all'>
            <i className='icon-chevron-right pull-right' />
            <b>全てのカテゴリを表示</b>
          </a>
        </li>
        {sharedFileCategorySelector}
      </ul>
    )
  }
  render () {
    if (!this.state.isSharedFileCategorySettingLoaded ||
        !this.state.isSharedFileSettingLoaded) {
      return <Loading />
    }
    const sharedFileBox = this.renderSharedFileBox(this.state)
    const pageNavi = this.renderPageNavi()
    const categoryListBox = this.renderCategoryListBox()
    return (
      <div>
        {pageNavi}
        <section className='page container'>
          <div className='row'>
            <div className='span4 kw-category-area'>
              <div className='blockoff-right'>
                {categoryListBox}
              </div>
            </div>
            <div className='span12 kw-category-content-area'>
              {sharedFileBox}
            </div>
          </div>
        </section>
      </div>
    )
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
}

export default SharedFileList



// WEBPACK FOOTER //
// ./src/common/pages/secure/SharedFileList.js